import { render } from "./loading_animation.vue?vue&type=template&id=c5179ff0&scoped=true"
import script from "./loading_animation.vue?vue&type=script&lang=js"
export * from "./loading_animation.vue?vue&type=script&lang=js"

import "./loading_animation.vue?vue&type=style&index=0&id=c5179ff0&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5179ff0"]])

export default __exports__